export const activitiesCalendar = {
  path: '/activities-calendar',
  name: 'activities-calendar',
  component: () => import('./views/activities.vue'),
  meta: {
    title: 'Календарь активностей',
    layout: 'redesign',
  },
};

const routes = [activitiesCalendar];

export default routes;
